<template>

  <div>
    <div class="titlePdf text-center html2pdf__page-break">
      <p class="font-size-36 text-dark font-weight-semibold" style="font-size: 36px;">判定結果</p>
      <div style="text-align: left;font-size: 18px;color: black;margin-top: 400px; margin-left: -100px;">
        <p>
          名前 :
          {{ infoPDF && infoPDF.information ? infoPDF.information.fullname : "" }}
        </p>
        <p>ID : {{ infoPDF.patient_id }}</p>
        <p>
          性別 :
          {{
            infoPDF.information && infoPDF.information.sex === 0
                ? "女性"
                : infoPDF.information && infoPDF.information.sex === 1
                ? "男性"
                : "無回答"
          }}
        </p>
        <p>質問 ：７つのロコチェック</p>
      </div>
    </div>

    <div class="row justify-content-center">
      <div class="col-9">
        <table>
          <tbody
              v-for="(history, index) in locomo7"
              class="html2pdf__page-break break-page"
              :key="index"
          >
          <tr style="cursor: pointer">
            <td style="border-bottom-width: 0">
              <div class="pt-5" style="padding-top: 5em !important">
                <p class="text-list-locomo-7">
                  {{ history.created_at | fomatDate2 }}
                </p>
                <div class="col-md-12">
                  <h5 class="card-title">
                    {{ history.current_score }} / {{ history.max_score }}
                    {{ $t("menuitems.hospital.points") }}
                  </h5>
                  <div
                      v-if="history.images && history.images.length > 0"
                      class="row"
                  >
                    <div
                        class="col-12 p-3"
                        v-for="(image, i) in history.images"
                        :key="i"
                    >
                      <div
                          :class="{
                            'p-15': i === 6,
                          }"
                          class="d-flex align-items-center"
                      >
                        <img
                            :src="`${
                              image.url
                            }?x-request=html`"
                            alt
                            crossorigin="anonymous"
                            style="height: 200px; width: auto; margin-top: 12px;"
                        />
                        <h6
                            class="text-image-locomo-7 p-xl-4 align-items-center"
                        >
                          {{ image.name }}
                        </h6>
                      </div>
                    </div>
                  </div>
                  <div
                      v-else
                      class="d-flex justify-content-center align-items-center"
                      style="font-size: 22px;"
                  >
                    チェックされた項目はありません。
                  </div>
                </div>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import {filter} from "../../helpers/Vue-Filter";

export default {
  filters: {
    ...filter,
  },
  props: ["locomo7", "infoPDF"],

  data() {
    return {
      images: [],
    };
  },

  async created() {
    if (this.locomo7 && this.locomo7.length > 0) {
      this.images = this.locomo7[0].images;
    }
  },

  mounted() {
  },

  computed: {},

  watch: {
    //     locomo7: {
    //   handler(value) {
    //     if (value && value.length > 0) {
    //       this.getAnswersId(value[0].uuid);
    //     }
    //   },
    // },
  },

  methods: {
    getImages(index) {
      try {
        this.images = this.locomo7[index].images;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.titlePdf {
  margin: auto;
  width: 50%;
  padding: 10px;
  margin-top: 50%;
}

.titlePdf {
  margin: auto;
  width: 50%;
  padding: 10px;
  //   height: 100px !important;
  margin-top: 50%;
}

.text-list-locomo-7 {
  color: #1d1d1d;
  font-size: 16px;
  font-weight: 700;
}

.text-list-time {
  color: #404040;
  font-weight: 400;
  font-size: 14px;
}

* {
  font-family: "Noto Sans JP";
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #d3d3d3 !important;
  opacity: 1; /* Firefox */
}

::-webkit-input-placeholder {
  color: #d3d3d3 !important;
  opacity: 1; /* Firefox */
}

.text-table {
  color: #404040;
}

.text-link {
  color: #336aff;
}

.bg-active-locomo {
  background: #f8f9fa;
}

.text-end {
  align-items: end;
}

.scroll {
  height: 300px;
  overflow-y: scroll;
}

/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.p-15 {
  padding-top: 10em !important;
}

.font-size-36 {
  font-size: 36px;
}
</style>
